/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Text, Typography } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';
import React from 'react';

import { useSelector } from 'react-redux';

import { enterpriseColors } from '../../../../style/colors';
import { State } from '../../../../redux';
import { NotaryAPI } from '../../../../api/notary/types';
import { defaultTo } from '@utils/lodash';

const styles = StyleSheet.create({
  wrapper: {
    ...Typography.Roboto(),
    color: enterpriseColors.NEUTRAL_800,
    padding: '20px 20px',
    maxWidth: 600,
    border: `1px solid ${enterpriseColors.NEUTRAL_200}`,
    borderRadius: 6,
    backgroundColor: enterpriseColors.WHITE,
    alignItems: 'start',
  },

  instructionCard: {
    color: enterpriseColors.NEUTRAL_700,
    margin: 7,
    fontSize: 14,
  },
});

export const SpecialInstructionsCard: React.FC = ({}) => {
  const roomDetail = useSelector((reduxState: State) => reduxState.roomDetail);
  const metadata = roomDetail.metadata as NotaryAPI.RoomMetadata;
  return (
    <div className={css(styles.wrapper)}>
      <div data-it="lenderSpecialInstructions" className={css(styles.instructionCard)}>
        <Text>{defaultTo(metadata?.specialInstructions, 'No Lender Instruction Available')}</Text>
      </div>
    </div>
  );
};
